import { render } from "./ClientSideValidation.vue?vue&type=template&id=7af6e544"
import script from "./ClientSideValidation.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientSideValidation.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/checkout/ClientSideValidation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7af6e544"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7af6e544', __exports__)) {
    api.reload('7af6e544', __exports__)
  }
  
  module.hot.accept("./ClientSideValidation.vue?vue&type=template&id=7af6e544", () => {
    api.rerender('7af6e544', render)
  })

}


export default __exports__